import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { useDispatch } from "react-redux";
import { getDefaultSettings } from "../Redux/actions/defaultSettingsActions";
import { New_ScrollX2025 } from "../assets/icons/index";
import Setting from "../Pages/Setting/Setting";
import { IoMdArrowRoundBack } from "react-icons/io";
export default function NavBar() {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const profileBtnRef = useRef(null);

  useEffect(() => {
    dispatch(getDefaultSettings());
  }, [dispatch]);

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U";
  };

  const getBackgroundColor = () => "#7c5cff26";

  return (
    <>
      <nav className="w-full h-full flex flex-wrap justify-between items-center text-slate-200 focus:text-sly-700 drop-shadow-2xl">
        
        <div className="w-full h-full flex flex-wrap items-center justify-between ">

          <div className="flex items-center gap-3 min-w-0">
            
            <div className="arrowIcon flex items-center opacity-0  bg-transparent "><IoMdArrowRoundBack className="bg-transparent" size={20} /></div>
          
            <div className="h-[17px] w-[1px] bg-transparent" />

            <div className="w-full h-full flex items-center gap-2.5 text-sx-ink font-semibold text-[15px] tracking-tight">
              <a href="https://scrollx.io/" className="nav-logo">
                <img className="w-[35px] h-[35px]" src={New_ScrollX2025} alt="ScrollX" />
                <span className="font-body text-[18px]">ScrollX</span>
              </a>
            </div>
          </div>

          <div className="w-[15%] flex justify-center items-center">
            <h1 className="font-body text-[15px] text-white">Dashboard</h1>
          </div>


          <div className="w-[15%] flex justify-end items-center">
            <button
              ref={profileBtnRef}
              type="button"
              className="w-[35px] h-[35px] flex justify-center items-center border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
              onClick={() => setIsSettingOpen((open) => !open)}
              style={{ backgroundColor: getBackgroundColor() }}
              aria-expanded={isSettingOpen}
              aria-haspopup="true"
            >
              <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
                <span className="font-body text-[#c4b2ff] text-lg text-center">
                  {getUserInitials()}
                </span>
              </div>
            </button>
          </div>
        
        </div>

      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
        anchorRef={profileBtnRef}
      />
    </>
  );
}
